import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks'

const ClusterTransferApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useUserContext()

  const appProps = {
    user,
    initialPath: location.pathname,
    onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
      const { pathname } = location

      if (pathname !== nextPathname) {
        navigate(nextPathname)
      }
    },
    isWidget: false
  }

  return (
    <FullPageAppTemplate
      skipPermissionCheck
      scope='cluster_transfer'
      envKey='clusterTransfer'
      entryPath='./ClusterTransferApp'
      url={process.env.REACT_APP_CLUSTER_TRANSFER_APP_DEV_PATH}
      appName='Cluster Transfer'
      appProps={appProps}
    />
  )
}

export { ClusterTransferApp }
